import * as React from 'react';

import './SubsidyCalculationForm.scss';

import Button from '@material-ui/core/Button';

import { CentrelinkStaticData, ChildCalculationResult, ChildcareCentreDetails, FamilyDetails, PersonalDetails, EnrolledChild, EnrolledChildWithHours } from '../Calculation/types';

import * as validator from "validator";

import { Step, StepConnector, StepContent, StepLabel, Stepper} from '@material-ui/core';

import { SubsidyCalculator } from '../Calculation/SubsidyCalculator';
import { GoogleTagManagerHelper } from '../Services/GoogleTagManagerHelper';
import { GravityFormsHelper } from '../Services/GravityFormsHelper';
import { ChildrenEnrolledInDaycare } from './ChildrenEnrolledInDaycare';
import { Estimate } from './Estimate';
import { FamilyIncomeAndActivity } from './FamilyIncomeAndActivity';
import { PersonalDetailsEntry } from './PersonalDetailsEntry';
import { SelectChildcareCentre } from './SelectChildcareCentre';
import { ChildEnrollmentDetails } from './SubsidyCalculationFormContainer';
import { string } from 'prop-types';
import './style.css';

interface Props {
  estimateCompleteUrl: string;
  customerDetailsUrl: string;
  enrolledChildrenCount: number;
  enrolledChildren: ChildEnrollmentDetails[];
  familyDetails: FamilyDetails;
  personalDetails: PersonalDetails;
  centrelinkData: CentrelinkStaticData;
  childcareCentreData: ChildcareCentreDetails[];
  selectedChildcareCentre?: ChildcareCentreDetails;
  maximumEnrolledChildren: number;

  onCombinedIncomeUpdated: (combinedTaxableIncome: number) => void;
  onKnowSubsidyDetailsUpdated: (knowSubsidyDetails: boolean) => void;
  onSubsidyPercentageUpdated: (subsidyPercentage: number | undefined) => void;
  onHoursEligableForSubsidyUpdated: (subsidizedHours: number | undefined) => void;
  onSelectedCentreUpdated: (value?: ChildcareCentreDetails) => void;
  onRecognisedActivityUpdated: (value: number) => void;
  onEnrolledChildrenCountUpdated: (value: number) => void;
  onEnrolledChildDetailsUpdated: (index: number, newDetails: ChildEnrollmentDetails) => void;
  onNameUpdated: (name: string) => void;
  onEmailUpdated: (email: string) => void;
  onNumberUpdated: (number: string) => void;
};

interface State {
  activeStep: number;
  estimates?: ChildCalculationResult[];
}

interface StepDetail {
  label: string;
  content: () => JSX.Element;
  nextButtonName?: string;
  validationCallback?: () => boolean;
}

export class SubsidyCalculationForm extends React.Component<Props, State> {
  private static readonly EstimationStepName = "Estimation";
  private nameRequired = false;
  private emailRequired = false;
  private numberRequired = false;

  constructor(props: Props) {
    super(props);

    this.state = {
      activeStep: 0,
    };
  }

  private get steps(): StepDetail[] {
    return [
      {
        label: "Centre details",
        content: () => <SelectChildcareCentre allCentres={this.props.childcareCentreData} selectedCentre={this.props.selectedChildcareCentre} onSelectedCentreChanged={this.props.onSelectedCentreUpdated} />,
        validationCallback: this.validateCentreDetails
      },
      {
        label: "Your children",
        content: () => <ChildrenEnrolledInDaycare enrolledChildren={this.props.enrolledChildren} enrolledChildrenCount={this.props.enrolledChildrenCount} maximumEnrolledChildren={this.props.maximumEnrolledChildren} onEnrolledChildDetailsUpdated={this.props.onEnrolledChildDetailsUpdated} onEnrolledChildrenCountUpdated={this.props.onEnrolledChildrenCountUpdated} />,
        validationCallback: this.validateEnrolledChildren
      },
      {
        label: "Family income & activity",
        content: () => <FamilyIncomeAndActivity familyDetails={this.props.familyDetails} onRecognisedActivityUpdated={this.props.onRecognisedActivityUpdated} onCombinedIncomeUpdated={this.props.onCombinedIncomeUpdated} onKnowSubsidyDetailsUpdated={this.props.onKnowSubsidyDetailsUpdated} onSubsidyPercentageUpdated={this.props.onSubsidyPercentageUpdated} onHoursEligableForSubsidyUpdated={this.props.onHoursEligableForSubsidyUpdated}  />,
        validationCallback: this.validateIncomeAndActivity
      },
      {
        label: "Your details",
        content: this.renderPersonalDetails,
        nextButtonName: "Estimate",
        validationCallback: this.validatePersonalDetails
      },
      {
        label: SubsidyCalculationForm.EstimationStepName,
        content: () => <Estimate className="" estimates={this.state.estimates} />,
        nextButtonName: "Done"

      }
    ]
  }

  public render() {
    const connector = (
      <StepConnector
        classes={{
          root: "step-connector",
        }}
      />
    );

    const activeStepDetails = this.steps[this.state.activeStep];
    const activeStepValid = !activeStepDetails.validationCallback || activeStepDetails.validationCallback();

    return (
      <div className="subsidy-calculation-form">
        <Stepper classes={{root: "stepper"}} orientation="vertical" activeStep={this.state.activeStep} connector={connector}>
          {this.steps.map((details, index) => {
            return <Step key={index}>
              <StepLabel classes={{root: "step-label"}} StepIconProps={{classes: {root: "step-icon", active: "active-step-icon", completed: "completed-step-icon", }}}>{details.label}</StepLabel>
              <StepContent classes={{root: "step-content"}}>
                {details.content()}
              <div className="stepper-navigation-buttons">
                <Button
                  className={"calculator-secondary-button"}
                  color="secondary"
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Back
                </Button>
                <Button
                  className={"md-background--primary"}
                  //color="secondary"
                  disabled={this.state.activeStep === this.steps.length || !activeStepValid }
                  onClick={this.handleNext}
                >
                  { details.nextButtonName || 'Next'}
                </Button>

                {/* <Button
                  flat={true}
                  className={"calculator-secondary-button"}
                  secondary={true}
                  disabled={this.state.activeStep === 0}
                  onClick={this.handleBack}
                >
                  Back
                </Button>
                <Button
                  flat={true}
                  primary={true}
                  disabled={this.state.activeStep === this.steps.length || !activeStepValid }
                  onClick={this.handleNext}
                  swapTheming={true}
                >
                  { details.nextButtonName || 'Next'}
                </Button> */}
            </div>              
              </StepContent>          
            </Step>
          })}
        </Stepper>      
      </div>
    );
  }

  private handleBack = () => {
    const currentStep = this.steps[this.state.activeStep];
    if (currentStep.label === SubsidyCalculationForm.EstimationStepName) {
      this.setState({estimates: undefined});
    }

    this.setState((state, props) => {
      return {activeStep: state.activeStep -1}
    });
  }

  private handleNext = () => {
    const nextStep = this.steps[this.state.activeStep + 1];

    if (nextStep && nextStep.label === SubsidyCalculationForm.EstimationStepName) {
      this.generateEstimate(); // Don't await this promise
    }

    if (this.state.activeStep === this.steps.length - 1) {
      window.location.href = this.props.estimateCompleteUrl;
    }

    this.setState((state, props) => {
      return {activeStep: state.activeStep +1}
    });
  }

  private async generateEstimate() {
    const { enrolledChildren, familyDetails, centrelinkData, selectedChildcareCentre, personalDetails, enrolledChildrenCount } = this.props;

    const calculator = new SubsidyCalculator(centrelinkData!);
    (window as any).calculator = calculator;
    const selectedCentrePricing = selectedChildcareCentre ? selectedChildcareCentre.pricing : undefined;
    let childEstimates: ChildCalculationResult[];

    if (selectedCentrePricing && this.validateEnrolledChildren()) {
        childEstimates = enrolledChildren
            .slice(0, enrolledChildrenCount)
            .map(c => {
              if (c.attendHoursPerDay !== undefined) {
                return calculator.calculateEnrolledChild(c as EnrolledChildWithHours, familyDetails, selectedCentrePricing);
              } else {
                return calculator.calculateEnrolledChildMinimizeGapMaximizeHours(c as EnrolledChild, familyDetails, selectedCentrePricing);
              }});
    } else {
        childEstimates = [];
    }

    const tagHelper = new GoogleTagManagerHelper();
    tagHelper.addEstimationCompleteVirtualPageViewEvent();
    tagHelper.addEstimationCompleteEvent(childEstimates, personalDetails);

    const gravityFormsHelper = new GravityFormsHelper(this.props.customerDetailsUrl);

    // Wait for tag submission & gravity form submission
    await Promise.all([tagHelper.flush(), gravityFormsHelper.postDetails(personalDetails, selectedChildcareCentre, childEstimates, familyDetails)]);

    this.setState({estimates: childEstimates});
  }

  private validateCentreDetails = () => {
    return !!this.props.selectedChildcareCentre    
  }

  private validateEnrolledChildren = () => {
    const childMissingDetails = (details: ChildEnrollmentDetails) => {
      return details.ageInMonths ===  undefined || details.attendSessionsPerWeek === undefined ||  details.ageInMonths <= 0
    }

    return !this.props.enrolledChildren.slice(0, this.props.enrolledChildrenCount).find(childMissingDetails)
  }

  private validateIncomeAndActivity = () => {
    if (this.props.familyDetails.knowSubsidyDetails) {
      return this.props.familyDetails.subsidyPercentage !== undefined && this.props.familyDetails.hoursEligableForSubsidyPerFortnight !== undefined;
    }

    return this.props.familyDetails.activityHoursPerFortnight !== undefined;
  }

  private validatePersonalDetails = () => {
    return this.validateEmail(this.props.personalDetails.email).valid && this.validateName(this.props.personalDetails.preferredName).valid && this.validateNumber(this.props.personalDetails.number).valid;
  };

  private renderPersonalDetails = () => {
    const personalDetailsValidatorMessages = {
      email: this.validateEmail(this.props.personalDetails.email).message,
      name: this.validateName(this.props.personalDetails.preferredName).message,
      number: this.validateNumber(this.props.personalDetails.number).message
    };

    return <PersonalDetailsEntry validatorErrorMessages={personalDetailsValidatorMessages} nameRequired={this.nameRequired} emailRequired={this.emailRequired} numberRequired={this.numberRequired} personalDetails={this.props.personalDetails} onNameUpdated={this.props.onNameUpdated} onEmailUpdated={this.props.onEmailUpdated} onNumberUpdated ={this.props.onNumberUpdated}></PersonalDetailsEntry>;
  }
  
  private validateEmail(email: string): ValidationResult {
    if (validator.isEmail(email)) {
      return {
        valid: true
      };        
    }

    if (validator.isEmpty(email)) {
      if (this.emailRequired) {
        return {
          valid: false,
          message: "Email must be provided"
        };
      } else {
        return {
          valid: true
        };
      }
    }

    // Non empty, non-valid.
    return {
      valid: false,
      message: "Not a valid email address"
    };
  }

  private validateName(name: string): ValidationResult {
    return validator.isLength(name, {max: 1 }) ? {
      valid: false,
      message: "Name must be provided (minimum two characters)"
    } : {
      valid: true
    } 
  }  

  private validateNumber(number: string): ValidationResult {
    return validator.isLength(number, {max: 5}) ? {
      valid: false,
      message: "Number must be provided (minimum six characters)"
    } : {
      valid: true
    }
  }
  
}


interface ValidationResult { 
  valid: boolean;
  message?: string
}

export default SubsidyCalculationForm;
